<template>
<div>
    <form class="form-horizontal" @submit.prevent="submit">
        <fieldset>
            <legend></legend>
            <form-group label="Nazwa" :error="errors['name']">
                <text-input v-model="product.name"></text-input>
            </form-group>

            <form-group label="Odmiana" :error="errors['variety']">
                <text-input v-model="product.variety"></text-input>
            </form-group>

            <form-group label="Pochodzenie" :error="errors['origin']">
                <select-input v-model="product.origin" :options="originOptions"></select-input>
            </form-group>

            <form-group label="Jednostka" :error="errors['unit']">
                <text-input v-model="product.unit"></text-input>
            </form-group>
        </fieldset>

        <submit-button :submitting="submitting"></submit-button>
    </form>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import FileInput from './FileInput.vue'
import MediaInput from './MediaInput.vue'
import TextareaInput from './TextareaInput.vue'
import SubmitButton from './SubmitButton.vue'
import SelectInput from './SelectInput.vue'
import TableInput from './TableInput.vue'
import Api from './../api'
import flash from './../Flash'
import vSelect from 'vue-select'
import { origins } from '../helpers'

export default {
  props: {
    id: {type: [String, Number]}
  },
  components: {
    FormGroup,
    TextInput,
    FileInput,
    MediaInput,
    TextareaInput,
    SubmitButton,
    SelectInput,
    TableInput,
    vSelect,
    Api
  },
  data () {
    return {
      submitting: false,
      product: {
        name: '',
        variety: '',
        origin: 'kraj',
        unit: ''
      },
      originOptions: origins,
      errors: []
    }
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      let product = {...this.product}
      Api.product.post(product).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
    },
    updateSuccess () {
      flash.success('Zapisano zmiany poprawnie')
      this.$router.push({
        name: 'Records'
      })
    },
    updateError ({body}) {
      const violations = body.violations
      violations.forEach(violation => {
        this.errors[violation.propertyPath] = violation.message
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductAddEdit.vue?21f07153